import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import Header from '../components/Header';
import api from '../api';
import { formatarData } from '../utils/datas';

const fmt = (d) => formatarData(d) || '—';

export default function Atas() {
  const [sp, setSp] = useSearchParams();
  const pastaId = sp.get('pasta');
  const [pastas, setPastas] = useState([]);
  const [atas, setAtas] = useState([]);
  const [podeGerir, setPodeGerir] = useState(false);
  const [carregando, setCarregando] = useState(true);
  const [busca, setBusca] = useState('');

  useEffect(() => {
    api.get('/atas/pastas')
      .then(({ data }) => { setPastas(data.pastas); setPodeGerir(!!data.pode_gerir); })
      .catch(err => Swal.fire('Erro', err.response?.data?.error || 'Não foi possível carregar as pastas.', 'error'))
      .finally(() => setCarregando(false));
  }, []);

  useEffect(() => {
    if (!pastaId) { setAtas([]); return; }
    api.get('/atas', { params: { pasta_id: pastaId } })
      .then(({ data }) => setAtas(data.atas))
      .catch(() => setAtas([]));
  }, [pastaId]);

  const pasta = pastas.find(p => String(p.id) === String(pastaId));
  const lista = atas.filter(a => !busca.trim() || a.titulo.toLowerCase().includes(busca.trim().toLowerCase()));

  return (
    <>
      <Header />
      <main className="conteudo-container" style={{ maxWidth: 980 }}>
        <Link to="/documentos" className="doc-voltar"><i className="bi bi-arrow-left"></i> Documentos</Link>

        <div className="adm-topo">
          <div>
            <h1>{pasta ? pasta.nome : 'Atas de Reunião'}</h1>
            <p>{pasta
              ? (pasta.descricao || 'Atas dessa reunião, da mais recente pra mais antiga.')
              : 'Cada pasta é uma reunião. Você só enxerga as pastas liberadas pro seu cargo.'}</p>
          </div>
          {podeGerir && (
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
              <Link to="/atas/pastas" className="btn btn-outline-secondary"><i className="bi bi-folder2 me-1"></i> Pastas</Link>
              <Link to={`/atas/nova${pastaId ? `?pasta=${pastaId}` : ''}`} className="btn-centrao"><i className="bi bi-plus-lg me-1"></i> Nova ata</Link>
            </div>
          )}
        </div>

        {carregando && <div>Carregando…</div>}

        {!carregando && !pastaId && (
          <>
            {pastas.length === 0 && (
              <div className="conteudo-card adm-vazio">
                <i className="bi bi-folder2-open" style={{ fontSize: '2.2rem' }}></i>
                <p style={{ marginTop: 10 }}>
                  {podeGerir ? 'Nenhuma pasta criada ainda. Comece criando uma pasta por tipo de reunião.' : 'Nenhuma reunião liberada pro seu cargo.'}
                </p>
              </div>
            )}
            <div className="adm-hub-grid">
              {pastas.map(p => (
                <Link key={p.id} to={`/atas?pasta=${p.id}`} className="adm-hub-card">
                  <i className="bi bi-folder2"></i>
                  <div style={{ minWidth: 0 }}>
                    <div className="adm-hub-card-titulo">{p.nome}</div>
                    <div className="adm-hub-card-desc">
                      {p.qtd_atas} ata(s)
                      {p.tarefas_abertas > 0 && <> · <span className="adm-badge adm-badge--alerta">{p.tarefas_abertas} tarefa(s) aberta(s)</span></>}
                    </div>
                    {podeGerir && (
                      <div className="adm-sub" style={{ marginTop: 4 }}>
                        {p.perfis.length ? `Liberada: ${p.perfis.map(x => x.titulo).join(', ')}` : '⚠️ sem cargo liberado — só RH e diretoria veem'}
                      </div>
                    )}
                  </div>
                </Link>
              ))}
            </div>
          </>
        )}

        {!carregando && pastaId && (
          <>
            <div className="adm-filtros">
              <Link to="/atas" className="btn btn-outline-secondary btn-sm"><i className="bi bi-arrow-left"></i> Todas as pastas</Link>
              <div className="doc-busca" style={{ flex: 1, minWidth: 200, marginBottom: 0 }}>
                <i className="bi bi-search"></i>
                <input type="text" placeholder="Buscar ata…" value={busca} onChange={e => setBusca(e.target.value)} />
                {busca && <button type="button" className="doc-busca-limpar" onClick={() => setBusca('')}>×</button>}
              </div>
            </div>

            <div className="adm-tabela-wrap">
              <table className="adm-tabela">
                <thead><tr><th>Data</th><th>Ata</th><th className="adm-num">Tarefas</th><th></th></tr></thead>
                <tbody>
                  {lista.map(a => (
                    <tr key={a.id}>
                      <td style={{ whiteSpace: 'nowrap' }}>{fmt(a.data_reuniao)}</td>
                      <td><Link className="adm-link" to={`/atas/${a.id}`}>{a.titulo}</Link></td>
                      <td className="adm-num">
                        {a.total_tarefas === 0 ? <span className="adm-sub">—</span> : (
                          a.tarefas_abertas > 0
                            ? <span className="adm-badge adm-badge--alerta">{a.tarefas_abertas} aberta(s)</span>
                            : <span className="adm-badge adm-badge--ok">{a.total_tarefas} concluída(s)</span>
                        )}
                      </td>
                      <td>
                        <div className="adm-acoes">
                          <Link className="adm-btn-icone" to={`/atas/${a.id}`} title="Abrir"><i className="bi bi-eye"></i></Link>
                          {podeGerir && <Link className="adm-btn-icone" to={`/atas/${a.id}/editar`} title="Editar"><i className="bi bi-pencil"></i></Link>}
                        </div>
                      </td>
                    </tr>
                  ))}
                  {lista.length === 0 && <tr><td colSpan={4} className="adm-vazio">Nenhuma ata nessa pasta ainda.</td></tr>}
                </tbody>
              </table>
            </div>
          </>
        )}
      </main>
    </>
  );
}
